<div class="body d-flex py-lg-4 py-3">
    <div class="container">
        <div class="bd-content">

            <div *ngIf="!hasOrgs" class="card text-white bg-primary-gradient mb-3">
                <div class="card-header">Perfil incompleto</div>
                <div class="card-body">
                    <h5 class="card-title">Registra una empresa</h5>
                    <p class="card-text">Aún no tienes ninguna empresa registrada. Ve a "Registrar una empresa" para registrar una.</p>
                    <a style="color: white;" class="btn btn-outline-secondary" (click)="onClickOnboarding()">Registrar una empresa</a>
                </div>
            </div>

            <h2 id="how-it-works">Solución Integral para la Gestión Financiera de tu Negocio</h2>
            <p class="mt-3">Nuestra plataforma te ofrece una solución integral para organizar tus finanzas y optimizar la gestión de
            tu negocio. Con nuestro módulo exclusivo, podrás visualizar y controlar tus ingresos y egresos de manera
            sencilla, además de planificar el flujo de caja, todo completamente gratis. </p>

            <div class="container area-charts">
                <div class="row">
                  <div *ngFor="let chart of charts" class="col-sm">
                    <app-gtp-area-chart [label]="chart.label" [amount]="chart.amount" [subLabel]="chart.subLabel" [chartOptions]="chart.chartOptions"></app-gtp-area-chart>
                  </div>
                </div>
              </div>
            
            <div class="bullets card">
                <ul>
                    <li>Acceso rápido y sencillo a la información financiera.</li>
                    <li>Análisis de datos en tiempo real para tomar decisiones estratégicas.</li>
                    <li>Optimización de procesos contables y reducción de errores manuales.</li>
                    <li>Generación automática de informes financieros detallados.</li>
                    <li>Seguridad y confidencialidad de los registros comerciales.</li>
                </ul>
            </div>

            <div class="card mt-2 bar-chart">
                <h5>Evolutivo los ultimos 12 meses</h5>
                <app-gtp-bar-chart></app-gtp-bar-chart>
            </div>
        </div>
    </div>

</div>
